import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-transaction-quotation-popup',
  templateUrl: './transaction-quotation-popup.component.html',
  styleUrls: ['./transaction-quotation-popup.component.css']
})
export class TransactionQuotationPopupComponent implements OnInit {
  @ViewChild('quotationForm') quotationForm!: NgForm;

  quotationData: any = {
    businessName: '',
    workOrderNo: '',
    workingDate: '',
    worksite: '',
    toCustomerAddress: '',
    quotationPrintDate: new Date(),
    quotationTc: ['']
  };

  constructor(
    public dialogRef: MatDialogRef<TransactionQuotationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    // Pre-fill if metadata already exists
    if (this.data && this.data.metadata) {
      this.quotationData.businessName = this.data.metadata.businessName || '';
      this.quotationData.workOrderNo = this.data.metadata.workOrderNo || '';
      this.quotationData.workingDate = this.data.metadata.workingDate || '';
      this.quotationData.worksite = this.data.metadata.worksite || '';
      this.quotationData.toCustomerAddress = this.data.metadata.toCustomerAddress || '';
      this.quotationData.quotationPrintDate = this.data.metadata.quotationPrintDate ? new Date(this.data.metadata.quotationPrintDate) : new Date();

      if (this.data.metadata.quotationTc && Array.isArray(this.data.metadata.quotationTc)) {
        this.quotationData.quotationTc = [...this.data.metadata.quotationTc];
      }
    }

    // Give at least one empty item if the array is completely empty
    if (!this.quotationData.quotationTc || this.quotationData.quotationTc.length === 0) {
      this.addTc();
    }
  }

  addTc(value: string = '') {
    this.quotationData.quotationTc.push(value);
  }

  removeTc(index: number) {
    this.quotationData.quotationTc.splice(index, 1);
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  save() {
    if (this.quotationForm?.valid) {
      // Closes dialog and sends structured form data back to the invoker
      this.dialogRef.close(this.quotationData);
    }
  }
}